import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.href || undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="w-full bg-background-50 border-b border-background-200">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-2.5 flex items-center gap-1.5 text-sm">
          {items.map((item, index) => (
            <span key={index} className="flex items-center gap-1.5">
              {index > 0 && <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>}
              {item.href ? (
                <Link to={item.href} className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-800 font-medium whitespace-nowrap">{item.label}</span>
              )}
            </span>
          ))}
        </div>
      </nav>
    </>
  );
}